module.exports = "<header *ngIf=\"shouldShowHeader()\">\n    <dac-navbar [doubleNav]=\"false\"></dac-navbar>\n</header>\n<main>\n    <div class=\"container-fluid mt-3 mb-3\">\n        <div class=\"col-12 ml-auto mr-auto\" [ngClass]=\"{notSeamless: 'col-lg-8'}\">\n            <router-outlet></router-outlet>\n        </div>\n    </div>\n</main>"


//////////////////
// WEBPACK FOOTER
// ./src/app/assessments/assessments/assessments.component.html
// module id = ./src/app/assessments/assessments/assessments.component.html
// module chunks = main